import React, { useState } from 'react';
import { ArrowRight, Loader2, CheckCircle2 } from 'lucide-react';
import { submitToGoogleSheets } from '../utils/googleSheets';
export function SignupForm() {
  const [input, setInput] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMessage, setErrorMessage] = useState('');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!input.trim()) return;
    setStatus('loading');
    // Validate input
    const isValid = input.includes('@') || input.replace(/\D/g, '').length >= 10;
    if (!isValid) {
      setStatus('error');
      setErrorMessage('Please enter a valid email or phone number');
      return;
    }
    // Submit to Google Sheets
    const result = await submitToGoogleSheets(input, 'Signup Form (Bottom)');
    if (result.success) {
      setStatus('success');
      setInput('');
    } else {
      setStatus('error');
      setErrorMessage('Something went wrong. Please try again.');
    }
  };
  if (status === 'success') {
    return <div className="w-full max-w-md mx-auto p-6 bg-green-50 rounded-xl border border-green-100 text-center animate-in fade-in zoom-in duration-300" data-id="element-1">
        <div className="flex justify-center mb-3" data-id="element-2">
          <CheckCircle2 className="w-12 h-12 text-green-600" data-id="element-3" />
        </div>
        <h3 className="text-xl font-bold text-green-800 mb-2" data-id="element-4">
          You're on the list!
        </h3>
        <p className="text-green-700" data-id="element-5">
          Thanks for joining the SD Jewish Sports Group community.
        </p>
        <button onClick={() => setStatus('idle')} className="mt-4 text-sm font-semibold text-green-700 hover:text-green-800 underline" data-id="element-6">
          Register another person
        </button>
      </div>;
  }
  return <div className="w-full max-w-md mx-auto" data-id="element-7">
      <form onSubmit={handleSubmit} className="relative group" data-id="element-8">
        <div className="relative flex items-center" data-id="element-9">
          <input type="text" value={input} onChange={e => {
          setInput(e.target.value);
          if (status === 'error') setStatus('idle');
        }} placeholder="Enter email or phone number" className={`w-full px-6 py-4 pr-36 rounded-full border-2 outline-none transition-all duration-300
              ${status === 'error' ? 'border-red-300 bg-red-50 text-red-900 placeholder:text-red-300 focus:border-red-500' : 'border-gray-200 bg-white text-navy focus:border-primary focus:ring-4 focus:ring-primary/10'}
              text-lg placeholder:text-gray-400 shadow-sm group-hover:shadow-md`} aria-label="Email or phone number for updates" disabled={status === 'loading'} data-id="element-10" />
          <button type="submit" disabled={status === 'loading' || !input.trim()} className="absolute right-2 top-2 bottom-2 bg-primary hover:bg-blue-600 text-white px-6 rounded-full font-bold transition-all duration-300 disabled:opacity-70 disabled:cursor-not-allowed flex items-center gap-2 shadow-sm hover:shadow-md active:scale-95" data-id="element-11">
            {status === 'loading' ? <Loader2 className="w-5 h-5 animate-spin" data-id="element-12" /> : <>
                Join
                <ArrowRight className="w-4 h-4" data-id="element-13" />
              </>}
          </button>
        </div>
        {status === 'error' && <p className="absolute -bottom-8 left-6 text-red-500 text-sm font-medium animate-in slide-in-from-top-1" data-id="element-14">
            {errorMessage}
          </p>}
      </form>
    </div>;
}